import log from 'embed_v2/helpers/log'
import Poller from 'embed_v2/services/poller'
import visitor from 'embed_v2/services/visitor'
import qs from 'query-string'
import { v4 as uuidv4 } from 'uuid'
import Secrets from 'Secrets'
import pageItems from './pageItems'
import type { Item } from './ItemApi'
import type Session from 'embed_v2/types/session'

const uniqScriptID = uuidv4()
const globalName = '_wf'
const globalInitializationName = '_wf_initialized'

window[globalName] = window[globalName] || []
window.wfStartTime = window.wfStartTime || Date.now()
window.logDifference = (...args) => {
  const diff = Date.now() - window.wfStartTime

  log.debug(`[WF Perf #${uniqScriptID}]`, diff, ...args)
}

visitor.ensureSetToken()

log.info('init', uniqScriptID, window[globalInitializationName], window[globalName])
if (!window[globalInitializationName]) {
  window[globalInitializationName] = true

  const poller = new Poller()

  log.info('map array', uniqScriptID, window[globalName], window[globalName].forEach)

  const shiftItem = () => {
    const item = window[globalName].shift()
    if (item) {
      pageItems.push(item)
    }
  }

  while (window[globalName].length) {
    shiftItem()
  }

  poller.add('watch_wq', 50, shiftItem)
  poller.start()

  const { _wf_cid } = qs.parse(window.location.search)
  const qsCid = [_wf_cid].flat()[0]

  const publicApi: PublicApi = {
    getSession: (callbackFn, cid = qsCid) => {
      if (!cid) {
        callbackFn(null)

        return
      }

      fetch(`${Secrets.meetingHost}/embed/v2/sessions/${cid}`)
        .then(response => response.json())
        .then(response => {
          if (typeof callbackFn === 'function') {
            callbackFn(response.session)
          }
        })
    },
    all: () => pageItems.list,
    find: id => pageItems.list.find(el => el.uniqId === id)
  }

  window.WF_API = publicApi

  // TODO: keep wfInit function and expose API directly
  const exposeAPI = () => {
    if (typeof window.wfInit === 'function') {
      window.wfInit(publicApi)
      window.wfInit = null
    } else {
      setTimeout(exposeAPI, 1000)
    }
  }
  exposeAPI()
}

type PublicApi = {
  getSession: (callbackFn: (session: Session | null) => void, cid: string | null) => void
  all: () => Item[]
  find: (value: string) => Item | undefined
}

declare global {
  // oxlint-disable-next-line typescript/consistent-type-definitions
  interface Window {
    WF_API: PublicApi
    [globalName]: Item[]
    [globalInitializationName]: boolean
  }
}
